import type { AlertDefinition, FilterNode } from '@qronstat/shared';
import type { MetaIndex } from '../../model/meta';

export const regionMember = 'cities.region';

function isRegionCondition(node: FilterNode): boolean {
  return 'member' in node && node.member === regionMember;
}

export function regionApplies(meta: MetaIndex | null, metricId: string): boolean {
  if (!meta?.dimension(regionMember)) return false;
  const cube = meta.metric(metricId)?.cube;
  if (!cube) return false;
  return cube === 'cities' || (meta.fact(cube)?.reachable ?? []).includes('cities');
}

function filtersOf(def: AlertDefinition): FilterNode[] {
  return (def.filters ?? []) as FilterNode[];
}

export function regionsOf(def: AlertDefinition): string[] {
  for (const node of filtersOf(def))
    if ('member' in node && node.member === regionMember && node.operator === 'equals')
      return (node.values ?? []).map(String);
  return [];
}

export function withRegions(def: AlertDefinition, regions: readonly string[]): AlertDefinition {
  const rest = filtersOf(def).filter((node) => !isRegionCondition(node));
  return {
    ...def,
    filters: regions.length
      ? [...rest, { member: regionMember, operator: 'equals', values: [...regions] }]
      : rest,
  };
}
